export default [
  {
    name: 'event-pool-create',
    path: '/events/pools/create',
    component: () => import('@/views/events/pools/EventPoolManage')
  },
  {
    name: 'event-pool-edit',
    path: '/events/pools/:id/edit',
    component: () => import('@/views/events/pools/EventPoolManage')
  },
  {
    name: 'event-pool-view',
    path: '/events/pools/:id/view',
    component: () => import('@/views/events/pools/EventPoolManage')
  },
  {
    name: 'event-pool-find',
    path: '/events/pools/find',
    component: () => import('@/views/events/pools/EventPoolFind')
  }
]



// WEBPACK FOOTER //
// ./src/router/routeEventPools.js